export enum PccModelType {
  Reception = '002',
  Operation = '003'
}
